import { NotificationManager } from "react-notifications";
import { API } from "actions/api";
import browserHistory from "browser-history";

export const skipAutoshipOrder =
  (orderId, action, token = "") =>
  async dispatch => {
    try {
      let request = {
        type: API,
        route: `patient_portal/mobile/autoship/${orderId}/${action}`,
        method: "PUT"
      };
      if (token != "") {
        request.headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        };
      }
      const { message } = await dispatch(request);
      browserHistory.push({
        pathname: "/thanks",
        state: { message }
      });
    } catch (error) {
      console.error(error.message);
      NotificationManager.error(error.message);
    }
  };
